module.exports = __webpack_public_path__ + "8968446270d017c9668bd8bf4a2af59c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-23.png
// module id = 2498
// module chunks = 0